"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../constants");
function isIndexedDBAvailable() {
    try {
        return window.indexedDB ? constants_1.YES : constants_1.NO;
    }
    catch (e) {
        return constants_1.ERROR;
    }
}
exports.isIndexedDBAvailable = isIndexedDBAvailable;
